import { render, staticRenderFns } from "./RequestMultipartFormData.vue?vue&type=template&id=27dffcb6&scoped=true&"
import script from "./RequestMultipartFormData.vue?vue&type=script&lang=js&"
export * from "./RequestMultipartFormData.vue?vue&type=script&lang=js&"
import style0 from "./RequestMultipartFormData.vue?vue&type=style&index=0&id=27dffcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dffcb6",
  null
  
)

export default component.exports